import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Box, Typography, Button } from "@material-ui/core";

import CustomDateRangePicker from "../CustomDateRangePicker/CustomDateRangePicker";
import { useStyles } from "./DateFilterStyles";
import { getPriorDate } from "../../Containers/utils/getPriorDate";
import { isClearClickedStatus } from "../../Store/EkgReport/EkgReportActions";
import { REPORT_TYPE_MENU_OPTIONS } from "../../consts/ekgReportMenuOptionsConstants";

function DateFilter(props) {
  const { onDateSelection, selectedReportType, isExportClicked } = props;
  let selectedDateArray = [];
  const maxDate = new Date();

  const [selectedDateFilter, setSelectedDateFilter] = useState(0);
  const [selectedDate, setSelectedDate] = useState([null, null]);
  const [isCustomButtonClicked, setIsCustomButtonClicked] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  const isClearClicked = useSelector((state) => state.ekgReport.isClearClicked);

  const classes = useStyles();
  const dispatch = useDispatch();

  const onDaysFilterSelect = (priorDays, filterNumber) => {
    setIsCustomButtonClicked(false);
    setSelectedDateFilter(filterNumber);
    const daysPrior = getPriorDate(priorDays);
    selectedDateArray.push(daysPrior);
    selectedDateArray.push(maxDate);
    setSelectedDate(selectedDateArray);
  };

  const customButtonHandler = (filterNumber) => {
    setSelectedDateFilter(filterNumber);
    setSelectedDate([null, null]);
    setIsCustomButtonClicked(true);
  };

  onDateSelection(selectedDate);

  useEffect(() => {
    if (
      selectedReportType === REPORT_TYPE_MENU_OPTIONS[1].reportType ||
      selectedReportType === REPORT_TYPE_MENU_OPTIONS[2].reportType
    ) {
      setSelectedDateFilter(2);
      setSelectedDate([new Date(), new Date()]);
      setIsDisabled(true);
    } else {
      setSelectedDateFilter(0);
      setSelectedDate([null, null]);
      setIsDisabled(false);
    }
    setIsCustomButtonClicked(false);
  }, [selectedReportType]);

  useEffect(() => {
    setSelectedDateFilter(0);
    setSelectedDate([null, null]);
    setIsCustomButtonClicked(false);
    setIsDisabled(false);
    onDateSelection([]);
    dispatch(isClearClickedStatus(false));
  }, [isClearClicked, dispatch, onDateSelection]);

  return (
    <Box className={classes.container}>
      <Box className={classes.headingContainer}>
        <Typography className={classes.heading}>Date: </Typography>
      </Box>
      <Box className={classes.subHeadingContainer}>
        <Typography
          className={`${classes.subHeading} ${
            isExportClicked && (!selectedDate[0] || !selectedDate[1])
              ? classes.errorSubHeading
              : ""
          }`}
        >
          Select Date*
        </Typography>
      </Box>
      <Box className={classes.dateFilterContainer}>
        <Button
          disabled={false}
          className={`${classes.buttonStyle} ${classes.leftMostButtonStyle} ${
            selectedDateFilter === 2 ? classes.selectedDateFilter : ""
          }`}
          onClick={() => {
            onDaysFilterSelect(0, 2);
          }}
        >
          Today
        </Button>
        <Button
          className={`${classes.buttonStyle} ${
            selectedDateFilter === 3 ? classes.selectedDateFilter : ""
          }`}
          onClick={() => {
            onDaysFilterSelect(1, 3);
          }}
          disabled={isDisabled}
        >
          Yesterday
        </Button>
        <Button
          className={`${classes.buttonStyle} ${
            selectedDateFilter === 4 ? classes.selectedDateFilter : ""
          }`}
          onClick={() => {
            onDaysFilterSelect(7, 4);
          }}
          disabled={isDisabled}
        >
          Last 7 Days
        </Button>
        <Button
          className={`${classes.buttonStyle} ${
            selectedDateFilter === 5 ? classes.selectedDateFilter : ""
          }`}
          onClick={() => {
            onDaysFilterSelect(30, 5);
          }}
          disabled={isDisabled}
        >
          Last 30 Days
        </Button>
        {!isCustomButtonClicked && (
          <Button
            className={`${classes.buttonStyle} ${
              classes.rightMostButtonStyle
            } ${selectedDateFilter === 6 ? classes.selectedDateFilter : ""}`}
            onClick={() => {
              customButtonHandler(6);
            }}
            disabled={isDisabled}
          >
            Custom
          </Button>
        )}
        {isCustomButtonClicked && (
          <Box className={classes.dateRangePickerContainer}>
            <CustomDateRangePicker
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
              setSelectedDateFilter={setSelectedDateFilter}
              disabled={isDisabled}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default DateFilter;
